<template>
  <div class="result-summary">
    <h4 class="title-section">{{ title }}</h4>
    <div class="box-content p-grid">
        <div class="box-table p-col-12 p-sm-12 p-md-5 p-lg-5 p-xl-5">
            <table>
                <tr>
                    <th class="background-red-color">Loại điểm</th>
                    <th class="background-red-color">Điểm</th>
                    <th class="background-red-color">Vị thứ</th>
                </tr>
                
                <tr v-for="result, index in resultSummaryData" :key="'result-summary-' + index">
                    <td class="background-red-color color-yeallow">{{result['Loại điểm']}}</td>
                    <td class="background-yeallow-color color-red">{{result['Điểm']}}</td>
                    <td class="background-yeallow-color color-red">{{result['Vị thứ']}}</td>
                </tr>
            </table>
        </div>
        <div class="box-diagram p-col-12 p-sm-12 p-md-7 p-lg-7 p-xl-7">
            <!-- <Chart type="bar" :data="resultSummaryDiagram"/> -->
            <apexchart type="bar" :options="resultSummaryDiagram" :series="series"></apexchart>
        </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'ResultSummary',
  props: ['resultSummaryData', 'title'],
  components: {},
  data() {
    return {
        resultSummaryDiagram: {
            chart: {
                id: 'vuechart-result-summary',
                width: '100%'
            },
            xaxis: {
                categories: [],
            },
            colors: ['#EA9999'],
            title: {
                text: 'Kết quả tổng hợp',
                align: 'center',
                floating: true
            },
        },
        series: [{
            name: 'Kết quả tổng hợp',
            data: []
        }]
    }
  },
  watch: {
  },
  created() {
      this.convertDatatoDiagram()
  },
  methods: {
    convertDatatoDiagram(){
        let data = JSON.parse(JSON.stringify(this.resultSummaryData))
        let lab = []
        let value = []
        if (data.length > 0) {
            for (let index = 0; index < data.length; index++) {
                lab.push(data[index]['Loại điểm'])
                value.push(data[index]['Điểm'])
            }
        }
        // push data to diagram
        this.resultSummaryDiagram.xaxis.categories = lab
        this.series[0].data = value
    }
  }
}
</script>

<style>
</style>